import { DonationMatching } from '@/app/api';
import { CoinsIcon } from '@/app/components/CoinsIcon/CoinsIcon';
import { formatPrice } from '@/app/utils/formatting';
import { useMemo } from 'react';
import { Trans } from 'react-i18next';

type DonationMatchingWidgetProps = {
  donationMatching: DonationMatching;
  currentDonationValue: number;
};

export const DonationMatchingWidget = ({ donationMatching, currentDonationValue }: DonationMatchingWidgetProps) => {
  const { logo, name } = donationMatching;

  const amountWithCurrency = useMemo(() => formatPrice(currentDonationValue * 2), [currentDonationValue]);

  return (
    <div
      data-testid="matching-widget"
      className="mb-[32px] flex flex-col gap-[16px] items-center py-[24px] px-[16px] border border-neutral-light rounded-[4px] bg-neutral-white"
    >
      <div className="flex gap-[8px] items-center">
        <CoinsIcon className="text-black h-[24px] w-[24px]" />
        <span className="text-[14px]" data-testid="donation-matching-widget-title">
          <Trans
            i18nKey="components.DonationMatchingWidget.title"
            values={{ amountWithCurrency }}
            components={{ strong: <span className="font-bold" /> }}
          />
        </span>
      </div>
      {logo ? <img alt="company logo" src={logo} height={90} width={90} /> : <div>{name}</div>}
    </div>
  );
};
